import { ITatPeilutDdl } from '../../reports/peilut-reports/tat-peilut-ddl';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customeTatPeilutDdlFilter'
})
export class CustomerTatPeilutDdlFilter implements PipeTransform {
    transform(value: ITatPeilutDdl[], args: number): any {
        if (args > 0) {
            return value.filter(hero => hero.k_sug_peilut == args);
        }
        else { return value; }
    }
}